import React, { useRef, useState, useEffect, useCallback } from 'react';
import { ReactSVG } from 'react-svg';
//import {ReactComponent as BtnPrev} from '../../Assets/icon_chevron_left.svg';
//import {ReactComponent as BtnNext} from '../../Assets/icon_chevron_right.svg';
//import threeDBtnImg from '../../Assets/3D.png';
import classes from './preview.module.css';

const PointOfView = {
    Front: 'front',
    Right: 'right',
    Back: 'back',
    Left: 'left',
}

const SelectedViewer = {
    ThreeSixty: 'ThreeSixtyViewer',
    ThreeD: 'ModelViewer',
    TwoD: 'Lifestyle',
}

const Preview = (props) => {
    const [viewerBtnMapIndex, setViewerBtnMapIndex] = useState(0);
    const [buttons, setButtons] = useState([]);
    const [productSettings, setProductSettings] = useState(props.productSettings);
    const [viewpointScreenshots3D, setViewpointScreenshots3D] = useState(props.viewpointScreenshots3D);
    const [buttonSize, setButtonSize] = useState({ width: 50, height: 50 }); // Default size
    const [threeDModel, setThreeDModel] = useState(props.previewItems);
    
    // Update productSettings when props change
    useEffect(() => {
        console.log('Preview.js: Updating productSettings from props:', props.productSettings);
        setProductSettings(props.productSettings);
    }, [props.productSettings]);

    const buttonsAdded = useRef(false);
    const userAgent = navigator.userAgent || window.opera;
    const isMobileDevice = /Mobi|Android/i.test(userAgent) || (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)
        || (/android/i.test(userAgent));
    const verticalLayout = props.verticalLayout || false;
    //Limit number of buttons to 3 when the width is too low
    const maxVisibleButtons = (verticalLayout && (props.parentHeight > 550)) || (props.parentWidth > 550) ? props.productSettings.minNumberOfButtons || 4 : 3;
    console.log('maxVisibleButtons, verticalLayout', maxVisibleButtons, verticalLayout);
    const buttonsMargin = props.productSettings.buttonsMargin !== undefined ? props.productSettings.buttonsMargin : 10;
    const arrowColour = props.productSettings.arrowColour || "black";
    const [parentSize, setParentSize] = useState({
        width: props.parentWidth,
        height: props.parentHeight,
    });
    const [buttonsDivSize, setButtonsDivSize] = useState(props.buttonsDivSize);
    const [selectedViewer, setSelectedViewer] = useState(SelectedViewer.ThreeSixty);
    const selectedViewerRef = useRef(selectedViewer);
    
    // Update ref when state changes
    useEffect(() => {
        selectedViewerRef.current = selectedViewer;
    }, [selectedViewer]);

    //TODO: Review. If we don't have viewpoint images, we won't get any buttons
    //But we only want to update once we've downloaded all files
    //This doesn't get called when props change

    //We take the 2 previous and next arrow buttons into account
    const updateButtonSize = () => {
        console.log('Update buttons size, parent width, height:', parentSize.width, parentSize.height);
        //We're now calculating the size of the buttons to be optimal versus the height or width
        //TODO: Limit size of buttons if maxVisibleButtons * buttonsDivSize > parentSize.width
        const totalMargin = (maxVisibleButtons + 1) * buttonsMargin; // Total margin space between buttons
        console.log('Total margin:', totalMargin);
        const availableSpace = verticalLayout
            ? parentSize.height - totalMargin
            : parentSize.width - totalMargin;

        const size = availableSpace / (maxVisibleButtons + 2); // Adjusted button size

        setButtonSize({ width: Math.min(buttonsDivSize, size), height: Math.min(buttonsDivSize, size) });
        props.setCalculatedButtonsDivSize(Math.min(buttonsDivSize, size));
    };

    const toggleViewer = () => {
        const newViewer = productSettings.pure3D ? SelectedViewer.ThreeSixty : SelectedViewer.ThreeD;
        props.onSwitch3DViewer(newViewer);
    }

    useEffect(() => {
        if (props.parentWidth !== parentSize.width || props.parentHeight !== parentSize.height) {
            setParentSize({ width: props.parentWidth, height: props.parentHeight });
        }
        setButtonsDivSize(props.buttonsDivSize);
    }, [props.parentWidth, props.parentHeight, props.buttonsDivSize]);

    // Update button size whenever parentSize changes
    useEffect(() => {
        if (parentSize.width < 0 || parentSize.height < 0) return;
        updateButtonSize();
    }, [parentSize, verticalLayout, buttonsDivSize]);

    useEffect(() => {
        //Following code is only called once as buttonsAdded.current becomes true after the first pass
        //We don't want to add buttons twice => need to clear current buttons after the first pass
        if (props.viewpointImages || props.productImages || productSettings.pure3D || props.viewpointScreenshots3D) {
            setViewpointScreenshots3D(props.viewpointScreenshots3D);
            addButtons(props.viewpointScreenshots3D);
            buttonsAdded.current = true;
        }
    }, [props.viewpointImages, props.productImages, buttonSize, props.viewpointScreenshots3D, viewpointScreenshots3D, 
        productSettings, selectedViewer]);

    useEffect(() => {
        console.log('Preview.js: Selected viewer changed:', selectedViewer);
    },[selectedViewer])

    /*
 Change order of buttons based on the 3 numbers below, where -1 means we don't show the corresponding buttons at all
 Product settings:
 {
 "ThreeSixtyViewer": 2,
 "Lifestyle": 3,
 "ModelViewer": 1,
 "orientation": "horizontal"
}
 */

    const BtnPrev = ({ width, height, stroke, className }) => (
        <svg
            viewBox="0 0 512 512"
            width={width}
            height={height}
            className={className}
        >
            <g transform="matrix(-0.315249 0 0 0.315249 351.121 173.439)">
                <path d="m213.3 85.036 176.85 176.85-176.85 176.86" fill="none" stroke={stroke || "black"} strokeWidth="79.3px" />
            </g>
        </svg>
    );

    const BtnNext = ({ width, height, stroke, className }) => (
        <svg
            viewBox="0 0 512 512"
            width={width}
            height={height}
            className={className}
        >
            <g transform="matrix(0.315249 0 0 0.315249 160.879 173.439)">
                <path d="m213.3 85.036 176.85 176.85-176.85 176.86" fill="none" stroke={stroke || "black"} strokeWidth="79.3px" />
            </g>
        </svg>
    );

    console.log('Preview.js: Current productSettings:', productSettings);
    console.log('viewpointImages', props.viewpointImages);
    console.log('selected viewer ref', selectedViewerRef.current);

    const addButtons = useCallback((myviewpointScreenshots3D) => {
        const buttonsToAdd = [];

        let povOrder = Object.keys(PointOfView);

        if (props.is180Pan) {
            // If is180Pan, change order and exclude 'Back'
            povOrder = ['Left', 'Front', 'Right'];
        }

        const hasNonEmptyValue = (val) => {
            if (Array.isArray(val)) return (val.length > 0 && val[0] !== "");
            if (typeof val === "string") return val.trim() !== "";
            return false;
        };

        //Create an array where the value is the order in which buttons should be rendered
        const settingsOrder = [
            {
                //Add the 3D button
                key: 'ModelViewer',
                value: productSettings.ModelViewer,
                addButton: () => {
                    console.log('Adding viewer buttons:', threeDModel);
                    if (hasNonEmptyValue(threeDModel)) {
                        buttonsToAdd.push(
                            <img
                                className={`PreviewImage ${verticalLayout ? 'verticalButton' : ''}`}
                                key="3D"
                                onClick={(toggleViewer)}
                                src={`${window.ASSET_BASE_URL || process.env.PUBLIC_URL}/ICON-ThreeDview.png`}
                                alt="3D model"
                                width={buttonSize.width}
                                height={buttonSize.height}
                            />
                        );
                    }
                }
            },
            {
                //Add 360 viewer point of view images
                key: 'ThreeSixtyViewer',
                value: productSettings.ThreeSixtyViewer,
                addButton: () => {
                    console.log('Adding 360 buttons');
                    console.log('viewpoint screenshots:', myviewpointScreenshots3D);
                    console.log('viewpoint images:', props.viewpointImages);
                    console.log('screenshots length:', myviewpointScreenshots3D.length);
                    console.log('viewpoint images length:', props.viewpointImages.length);
                    if (
                        (Array.isArray(myviewpointScreenshots3D) && myviewpointScreenshots3D.length > 0) ||
                        (Array.isArray(props.viewpointImages) && props.viewpointImages.length > 0) ||
                        (props.viewpointImages && Object.keys(props.viewpointImages).length > 0)
                      ) {
                        povOrder.forEach(key => {
                            //props.is180Pan
                            const pointOfView = PointOfView[key];
                            let imageUrl = null;
                            if (productSettings.pure3D) {
                                imageUrl = myviewpointScreenshots3D[pointOfView]?.dataURL;
                            } else if (props.viewpointImages) {
                                const val = props.viewpointImages[pointOfView];
                                imageUrl = Array.isArray(val) ? val[0] : val; // handles both string and array
                            }

                            console.log('image url:', imageUrl);

                            if (imageUrl && imageUrl !== "") {
                                buttonsToAdd.push(
                                    <img
                                        className={`PreviewImage ${verticalLayout ? 'verticalButton' : ''}`}
                                        key={pointOfView}
                                        onClick={() => props.onChangeView(pointOfView)}
                                        src={imageUrl}
                                        alt={pointOfView}
                                        width={buttonSize.width}
                                        height={buttonSize.height}
                                    />
                                );
                            }
                        });
                    }

                    //Add the top view image 
                    const topImage = props.productImages.find(imgObj => imgObj.image.includes('_top.jpg'));
                    if (topImage) {
                        buttonsToAdd.push(
                            <img
                                className={`PreviewImage ${verticalLayout ? 'verticalButton' : ''}`}
                                key='topImage'
                                id={topImage.image}
                                onClick={() => props.OnChangePicture(topImage.image)}
                                src={topImage.thumbnail ? topImage.thumbnail : topImage.image}
                                alt='Product'
                                width={buttonSize.width}
                                height={buttonSize.height}
                            />
                        );
                    }
                }
            },
            {
                //Go through productImages map and spawn buttons
                key: 'Lifestyle',
                value: productSettings.Lifestyle,
                addButton: () => {
                    console.log('Adding lifestyle buttons');
                    props.productImages.map((productImage, index) => {
                        if (productImage.image.includes('_top.jpg')) return; // Avoid adding top view again
                        buttonsToAdd.push(
                            <img
                                key={index}
                                id={productImage.image}
                                onClick={() => props.OnChangePicture(productImage.image)}
                                src={productImage.thumbnail ? productImage.thumbnail : productImage.image}
                                alt='Product'
                                width={buttonSize.width}
                                height={buttonSize.height}
                            />
                        );
                    });
                }
            }
        ];

        // Filter out settings with a value of -1, and then sort by their values
        const validSettings = settingsOrder
            .filter(setting => setting.value > -1)
            .sort((a, b) => a.value - b.value);

        // Add buttons in the order of the sorted settings
        validSettings.forEach(setting => {
            setting.addButton();
        });

        setButtons(buttonsToAdd);
    }, [props.viewpointImages, props.productImages, buttonSize, props.viewpointScreenshots3D, viewpointScreenshots3D, 
        props.previewItems, selectedViewer, productSettings]);

    const handleNext = () => {
        //Cycle the index through the map
        setViewerBtnMapIndex((prevIndex) => (prevIndex + 1) % buttons.length);
    }

    const handlePrevious = () => {
        setViewerBtnMapIndex((prevIndex) => (prevIndex - 1 + buttons.length) % buttons.length);
    }

    const getVisibleButtons = () => {
        if (buttons.length <= maxVisibleButtons) {
            return buttons; // Show all buttons if they fit
        }

        const visibleButtons = [];
        for (let i = 0; i < maxVisibleButtons; i++) {
            const index = (viewerBtnMapIndex + i) % buttons.length;
            visibleButtons.push(buttons[index]);
        }
        return visibleButtons;
    };

    //Turn the arrow images to point up and down for vertical layout
    return (
        /*previewCarousel.verticalPreview needs to have its width set depending on the window size + 
        all viewer components need to get their size reduced accordingly */
        <div className={`previewCarousel ${verticalLayout ? 'verticalPreview' : ''}`}>

            <button
                className={`buttonViewer ${verticalLayout ? 'verticalButton' : ''}`}
                onClick={handlePrevious}>
                {/* disabled={viewerBtnMapIndex === 0}> */}
                <BtnPrev
                    alt="Prev"
                    width={buttonSize.width}
                    height={buttonSize.height}
                    className={verticalLayout ? "rotateUp" : ""}
                    stroke={arrowColour}
                />

            </button>
            {getVisibleButtons().map((button, index) => (
                <div key={index} className={`previewItem ${verticalLayout ? 'verticalButton' : ''}`}>
                    {button}
                </div>
            ))}
            <button
                className={`buttonViewer ${verticalLayout ? 'verticalButton' : ''}`}
                onClick={handleNext} >
                {/* disabled={viewerBtnMapIndex >= buttons.length - 4}> */}
                <BtnNext
                    alt="Next"
                    width={buttonSize.width}
                    height={buttonSize.height}
                    className={verticalLayout ? "rotateDown" : ""}
                    stroke={arrowColour}
                />
            </button>
        </div>
    )
}

export default Preview;